import { Button, ButtonLink } from '@poseidon/components/Input2';
import { Arrows, General } from '@poseidon/components/StrokeIcons';

import { AuthProblemCard } from '~/components/AuthProblemCard';

/**
 * Shown instead of the login redirect when user.me keeps failing while you're impersonating. /login
 * can't fix that (you're still signed in and the session is still stored), so this offers the ways out.
 */
export const ImpersonationLoadFailed = ({
  email,
  onStopImpersonating,
}: {
  email: string;
  onStopImpersonating: () => void;
}) => (
  <div
    className="flex h-screen w-screen flex-col items-center justify-center px-6 dark:bg-slate-900"
    data-testid="impersonation-load-failed">
    <AuthProblemCard title={`Couldn't load the app while acting as ${email}`}>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Stop impersonating to get back to your own account, or reload to try again. If neither works, sign out and back
        in.
      </p>
      <div className="flex w-full flex-col gap-2 sm:flex-row sm:justify-center">
        <Button color="blue" onClick={onStopImpersonating}>
          Stop impersonating
        </Button>
        <Button tone="outline" icon={<Arrows.RefreshCcw05 />} onClick={() => window.location.reload()}>
          Reload page
        </Button>
        <ButtonLink color="red" tone="outline" icon={<General.LogOut05 />} href="/logout">
          Sign out
        </ButtonLink>
      </div>
    </AuthProblemCard>
  </div>
);
